'use client'
import { useEffect } from 'react'

export const CookieInitializer = () => {
  useEffect(() => {
    // customer_idがなければクライアント側で発行
    if (!document.cookie.includes('customer_id')) {
      const id = Math.random().toString(32).substring(2)
      const expires = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 3)
      document.cookie = `customer_id=${id}; Path=/; Expires=${expires.toUTCString()}; SameSite=Lax; Secure`
    }
  }, [])
  return null
}
